import type { FlattenSimpleInterpolation } from 'styled-components';
import styled from 'styled-components';
import type { HeaderStyledNavItemProps } from '../../interfaces/header-styled-components.interfaces';
import { createBreakpointStyles } from '../../services';
import { responsiveStyles } from '../../utils/responsiveStyles';
import { AudiCopy1WithHoverStyle } from '../AudiHeader/AudiHeaderStyleUtils';
import type { CustomTheme } from '../../../@types/theme';

type NavItemsStylesArray = Array<{ maxNavItems: number; style: unknown }>;
const headerStyledNavItemStyles = (theme?: CustomTheme): NavItemsStylesArray => [
  {
    maxNavItems: 0,
    style: null,
  },
  {
    maxNavItems: 4,
    style: {
      margin: {
        l:
          theme?.type === 'alpha'
            ? 'var(--one-header-alpha-menu-top-spacing) var(--one-header-space-l) 0 0'
            : 'var(--one-header-space-l) var(--one-header-space-l) 0 0',
      },
      padding: { l: '0' },
    },
  },
  {
    maxNavItems: 5,
    style: {
      margin: {
        xl:
          theme?.type === 'alpha'
            ? 'var(--one-header-alpha-menu-top-spacing) var(--one-header-space-l) 0 0'
            : 'var(--one-header-space-l) var(--one-header-space-l) 0 0',
      },
      padding: { xl: '0' },
    },
  },
  {
    maxNavItems: 8,
    style: {
      margin: {
        xxl:
          theme?.type === 'alpha'
            ? 'var(--one-header-alpha-menu-top-spacing) var(--one-header-space-l) 0 0'
            : 'var(--one-header-space-l) var(--one-header-space-l) 0 0',
      },
      padding: { xxl: '0' },
    },
  },
  {
    maxNavItems: -1, // > 8 navItems
    style: {
      margin: {
        xs:
          theme?.type === 'alpha'
            ? 'var(--one-header-alpha-menu-top-spacing) 0'
            : 'var(--one-header-space-l) 0',
      },
    },
  },
];

const headerStyledNavItemIconStyles = (): NavItemsStylesArray => [
  {
    maxNavItems: 0,
    style: null,
  },
  {
    maxNavItems: 4,
    style: {
      display: { l: 'none' },
    },
  },
  {
    maxNavItems: 5,
    style: {
      display: { xl: 'none' },
    },
  },
  {
    maxNavItems: 8,
    style: {
      display: { xxl: 'none' },
    },
  },
];

export const HeaderStyledNavItem = styled.div<HeaderStyledNavItemProps>`
  display: block;
  ${({ headerNavigationItemsAmount, theme }): string =>
    responsiveStyles(
      createBreakpointStyles(headerNavigationItemsAmount, headerStyledNavItemStyles(theme)),
      theme.breakpoints,
    )}
  padding: calc(var(--one-header-space-l) / 2) 0;

  &:last-of-type {
    margin-right: 0;
  }
`;

export const HeaderStyledNavItemLink = styled.a<{
  headerNavigationItemsAmount: number;
}>`
  ${({ theme }): FlattenSimpleInterpolation => AudiCopy1WithHoverStyle(theme)}
  color: ${({ theme }): string => theme.colors.colorBaseGrey60};
  display: flex;
  ${({ theme }): string => (theme.type !== 'legacy' ? 'justify-content: space-between;' : '')}
  flex-flow: row nowrap;
  text-decoration: none;

  &:hover,
  &:active,
  &:focus {
    color: ${({ theme }): string =>
      theme.type === 'legacy'
        ? 'var(--one-header-color-black);'
        : 'var(--one-header-color-hover);'};
  }

  &.top-active {
    ${({ theme }): string =>
      theme.type === 'alpha' ? 'font-weight: 700;' : 'color: var(--one-header-color-black);'};
  }

  & > svg {
    height: 24px;
    ${({ headerNavigationItemsAmount, theme }): string =>
      responsiveStyles(
        createBreakpointStyles(headerNavigationItemsAmount, headerStyledNavItemIconStyles()),
        theme.breakpoints,
      )}
    width: 24px;
  }
`;
